export const colorArrayToRGB = (
    c: [number, number, number] | [number, number, number, number]
): string => `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
